export const ADHOC_CONDITION_MESSAGE_MAX_LENGTH = 1000;
